import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import paths from 'paths';

const useStyles = makeStyles(() => ({
  title: {
    flexGrow: 1,
  },

  root: {
    color: 'white',
    textDecoration: 'none',
  },
}));

const HeaderNav: FC = () => {
  const classes = useStyles();

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" className={classes.title}>
          <Link to={paths.home} className={classes.root}>
            Curiosity Driven
          </Link>
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderNav;
